import React, { PureComponent } from "react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import loadingScreenNoText from "@assets/loading-screen-no-text.gif";
import {
  Plugin,
  Template,
  TemplatePlaceholder,
} from "@devexpress/dx-react-core";

interface LoadingPanelProps {
  isLoading: boolean;
  loadingClassname?: string;
}

export class LoadingPanel extends PureComponent<LoadingPanelProps> {
  render() {
    const { isLoading, loadingClassname } = this.props;
    return (
      <Plugin name="LoadingPanel">
        <Template name="root">
          <div className="relative">
            <TemplatePlaceholder />
            <div
              className={clsx(
                !isLoading && "hidden",
                "absolute flex-center h-full w-full top-0 bg-[rgba(200,200,200,0.5)] z-3",
              )}
            >
              <img
                src={loadingScreenNoText}
                alt="Loading screen gif"
                className={twMerge("w-3/4 max-w-xl", loadingClassname)}
              />
            </div>
          </div>
        </Template>
      </Plugin>
    );
  }
}
